// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__jZWsU","colMaxWidth":"Table_colMaxWidth__2T4fZ"};